import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { Anchor, Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { i18n } from '../contentReportTableMacroI18n.ts';

const styles = cssMap({
	container: {
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		paddingBlock: token('space.150'),
		paddingInline: token('space.150'),
	},
	heading: {
		color: token('color.text.subtlest'),
		font: token('font.body'),
		fontWeight: token('font.weight.semibold'),
		marginBlock: token('space.0'),
	},
	message: {
		color: token('color.text.subtlest'),
		marginBlock: token('space.0'),
	},
	createButton: {
		display: 'inline-block',
		marginBlockStart: token('space.100'),
		paddingBlock: token('space.075'),
		paddingInline: token('space.150'),
		backgroundColor: token('color.background.brand.bold'),
		color: token('color.text.inverse'),
		borderRadius: token('radius.small'),
		textDecoration: 'none',
		font: token('font.body'),
		fontWeight: token('font.weight.medium'),
	},
});

interface EmptyStateProps {
	blankTitle?: string;
	blankDescription?: string;
	createButtonLabel?: string;
	createContentUrl?: string;
	hasBlueprintExperience: boolean;
}

export const EmptyState = ({
	blankTitle,
	blankDescription,
	createButtonLabel,
	createContentUrl,
	hasBlueprintExperience,
}: EmptyStateProps) => {
	if (hasBlueprintExperience && blankTitle) {
		return (
			<Box xcss={styles.container} testId="content-report-table-blueprint-empty">
				<Stack space="space.100">
					<Box xcss={styles.heading} as="h2">
						{blankTitle}
					</Box>
					{blankDescription && (
						<Box xcss={styles.message} as="p">
							{blankDescription}
						</Box>
					)}
					{createButtonLabel && createContentUrl && (
						<Anchor href={createContentUrl} xcss={styles.createButton}>
							{createButtonLabel}
						</Anchor>
					)}
				</Stack>
			</Box>
		);
	}

	return (
		<Box xcss={styles.container} testId="content-report-table-empty-state">
			<Box xcss={styles.message} as="p">
				<FormattedMessage {...i18n.noResults} />
			</Box>
		</Box>
	);
};
